import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type SavingsGoalSlice = {
  selectedSavingsGoalId?: string;
};

const initialState: SavingsGoalSlice = {
  selectedSavingsGoalId: undefined
};

const { reducer, actions, selectors, reducerPath } = createSlice({
  name: 'savingsGoal',
  reducerPath: 'savingsGoal',
  initialState,
  reducers: {
    setSelectedSavingsGoalId: (state, action: PayloadAction<string | undefined>) => {
      state.selectedSavingsGoalId = action.payload;
    },

    clear: () => ({ ...initialState })
  },
  selectors: {
    selectSelectedSavingsGoalId: state => state.selectedSavingsGoalId
  }
});

export const SavingsGoalReducer = reducer;
export const SavingsGoalActions = actions;
export const SavingsGoalReducerPath = reducerPath;
export const { selectSelectedSavingsGoalId } = selectors;
